export default {
  countCells: 7,
  massive: [
    {
      dataField: 'mmm',
      cols: 1,
      rows: 1,
      text: '',
      class: 'd-flex align-center',
      headerStyles: `border: 1px solid #b7ced9; background: unset`,
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'mmm1',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9; align-items: center; padding-left: 10px; background: unset`,
      variable: false,
      text: `Число реализуемых образовательных программ - всего`,
    },
    {
      dataField: 'mmm2',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `align-items: center; padding-left: 10px; background: unset; border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9;`,
      styles: ``,
      variable: false,
      text: `Число образовательных программ, реализуемых с&nbsp;использованием сетевой формы, в&nbsp;которых организация выступает в&nbsp;роли базовой организации&nbsp;&mdash; всего`,
    },
    {
      dataField: 'bsm',
      cols: 1,
      rows: 1,
      text: 'Образовательные программы',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; background: unset; padding-left: 5px`,
      styles: 'border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; padding-left: 10px',
      variable: true,
      // template: (r) => r?.id
    },
    {
      dataField: 'qibcg20',
      cols: 1,
      rows: 1,
      text: 'в 2021/22 учебном году',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: true,
    },
    {
      dataField: 'qibcg21',
      cols: 1,
      rows: 1,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; ; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2022/23 учебном году`,
    },
    {
      dataField: 'qibcg22',
      cols: 1,
      rows: 1,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; ; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2023/24 учебном году`,
    },
    {
      dataField: 'qibcn20',
      cols: 1,
      rows: 1,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2021/22 учебном году`,
    },
    {
      dataField: 'qibcn21',
      cols: 1,
      rows: 1,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2022/23 учебном году`,
    },
    {
      dataField: 'qibcn22',
      cols: 1,
      rows: 1,
      variable: true,
      class: `justify-center`,
      headerStyles: `justify-content: center; background: unset; border-right: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9;',
      text: `в 2023/24 учебном году`,
    },
  ]
}